import { Box } from '@mantine/core';

export function ChatScrollBlur() {
  return (
    <Box
      pos="absolute"
      top={0}
      left={0}
      w="100%"
      h={64}
      style={{
        background:
          'linear-gradient(to bottom, rgba(255, 255, 255, 0.8) 0%, rgba(255, 255, 255, 0) 100%)',
        zIndex: 1,
        pointerEvents: 'none',
      }}
    />
  );
}
